<div class="topmost-container" *ngIf="isAuthenticated && shouldShowSidebar === false">
  <app-sidebar class="h-100"></app-sidebar>
  <div class="router-outlet-container">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-non-initialised
      *ngIf="isAuthenticated && selectedApp.app_versions && !selectedApp.app_versions.length && showDisclaimer && plan"
      [message]="'Please integrate Netcore Product Experience SDK with your app to start building Interaction Maps'"
      [href]="plan !== 'user_onboarding' ? docLinks.sdkIntegration[selectedApp.os] : docLinks.userOnboarding[selectedApp.os]"
      [buttonName]="'LEARN MORE'" [newPage]="true"></app-non-initialised>
  </div>
</div>

<router-outlet *ngIf="!isAuthenticated"></router-outlet>

<router-outlet *ngIf="isAuthenticated && shouldShowSidebar === true "></router-outlet>
